module.exports = __webpack_public_path__ + "static/media/email.e289dead.svg";